<template>
  <div>
    <!-- 定额会员开通 -->
    <el-dialog :title="$t('message.timedMembershipActivation')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="488px" center>
      <div class="content">
        <p>生效日期： <el-date-picker v-model="start_at" :placeholder="$t('message.startDate')" class="Container"
            type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 260px">
          </el-date-picker> </p>
        <div class="row" v-for="(item, index) in list" :key="index">
          <el-radio v-model="days" :label="item.days">第{{ index + 1 }}档：{{ item.days }}天 {{ item.pay }}円</el-radio>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
      days: "",
      start_at: '',
      vip_type: 1,
      list: []
    };
  },
  created() {
    this.$api.clienteleApi.vipList().then(res => {
      this.list = res.data
    })
  },
  methods: {
    // 保存
    save() {
      let datas = {
        user_id: this.$route.query.userID,
        days: this.days,
        vip_type: this.vip_type,
        start_at: this.start_at,
      };
      this.$api.clienteleApi.addPlan(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.clientDetail();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 8px;

  p {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 24px;
  }

  .row {
    margin-bottom: 24px;
  }

  /deep/.el-radio__input {
    transform: scale(1.5) !important;
  }
}
</style>